import React from 'react';

const Resources = () => {
  const resources = [
    {
      title: 'The Future of Web Design',
      category: 'Guide',
      date: 'Dec 2025',
      excerpt: 'Explore glassmorphism, neumorphism, and cutting-edge design trends',
      icon: '📘'
    },
    {
      title: '10 Tips for Better UX',
      category: 'Article',
      date: 'Dec 2025',
      excerpt: 'Essential principles for creating intuitive user experiences',
      icon: '✍️'
    },
    {
      title: 'AI Integration Blueprint',
      category: 'Whitepaper',
      date: 'Nov 2025',
      excerpt: 'Step-by-step guide for integrating AI into your applications',
      icon: '🤖'
    },
    {
      title: 'Performance Optimization Handbook',
      category: 'Guide',
      date: 'Nov 2025',
      excerpt: 'Advanced techniques for lightning-fast web applications',
      icon: '⚡'
    },
    {
      title: 'Security Best Practices 2025',
      category: 'Whitepaper',
      date: 'Oct 2025',
      excerpt: 'Comprehensive security strategies for modern web apps',
      icon: '🔒'
    },
    {
      title: 'Scaling Your Tech Stack',
      category: 'Case Study',
      date: 'Oct 2025',
      excerpt: 'How to grow your infrastructure without breaking the bank',
      icon: '📈'
    }
  ];

  return (
    <section id="resources">
      <div className="section-header">
        <h2 className="section-title">Resources & Blog</h2>
        <p className="section-subtitle">Expert guides, articles, and whitepapers to fuel your growth</p>
      </div>
      <div className="resources-grid">
        {resources.map((resource, index) => (
          <div className="resource-card fade-in" key={index} style={{animationDelay: `${(index % 3) * 0.1}s`}}>
            <div className="resource-icon">{resource.icon}</div>
            <div className="resource-badge">{resource.category}</div>
            <h3>{resource.title}</h3>
            <p>{resource.excerpt}</p>
            <div className="resource-footer">
              <span className="resource-date">{resource.date}</span>
              <button className="resource-link">Read More →</button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Resources;
